import { get } from 'lodash';


export class MyInfoAddressForm {
  postcode: string | undefined;
  block: string | undefined;
  unit: string | undefined;
  street: string | undefined;
  building: string | undefined;
  updateMailing: boolean | false;

  constructor(initial: any) {
    this.postcode = get(initial, 'postcode', undefined);
    this.block = get(initial, 'block', undefined);
    this.unit = get(initial, 'unit', undefined);
    this.street =  get(initial, 'street', undefined);
    this.building = get(initial, 'building', undefined);
    this.updateMailing =  get(initial, 'updateMailing', false);
  }
}
